"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _operators = _interopRequireDefault(require("../operators.js"));
var _CccisdSelect = _interopRequireDefault(require("../../CccisdSelect"));
var _formik = require("formik");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var Operator = function Operator(props) {
  var dataConnector = props.dataConnector,
    name = props.name;
  if (!dataConnector) {
    return null;
  }
  var options = [{
    value: '0',
    label: '- choose operator -'
  }].concat(_toConsumableArray(_operators["default"][dataConnector.type].map(function (operator) {
    return {
      value: operator.code,
      label: operator.title
    };
  })));
  return /*#__PURE__*/_react["default"].createElement(_formik.Field, {
    name: name,
    component: _CccisdSelect["default"],
    options: options,
    showErrorImmediately: true
  });
};
Operator.propTypes = {
  dataConnector: _propTypes["default"].object,
  name: _propTypes["default"].string
};
var _default = exports["default"] = Operator;